/**
*	PercentView
*
*	@version  0.0.1
*
*/
class PercentView
{
    /**
    *   Inizializziamo i parametri
    *
    *   @return {void}
    */
    constructor(element, callback)
    {
        this.element = this.getTarget(element);
        this.callback = this.normalizeCallbackParams(callback);

        this.inside = false;

        this.scopeOnScroll = this.onScroll.bind(this);

        this.init();
    }


    /**
    *   E tutto ebbe inizio!
    *
    *   @return {void}
    */
    init()
    {
        if( this.element === null )
        {
            console.log(`element not found`);
            return;
        }

        window.addEventListener('scroll', this.scopeOnScroll);
        window.addEventListener('resize', this.scopeOnScroll);

        setTimeout(()=>
        {
            this.onScroll();
        }, 1);
    }


    /**
    *   Allo scroll della pagina
    *
    *   @param  {object} event l'evento scroll
    *
    *   @return {void}
    */
    onScroll()
    {
        const rect = this.element.getBoundingClientRect();
        const vHeight = window.innerHeight;

        let percent = ( vHeight - rect.top ) / ( vHeight + rect.height );
        let percentRange = Math.min(1, Math.max(0, percent));

        let topInView = rect.top / vHeight;
            topInView = Math.min(1, Math.max(0, topInView));

        let bottomInView = rect.bottom / vHeight;
            bottomInView = Math.min(1, Math.max(0, bottomInView));

        const outputEvent =
        {
            target: this.element,
            percent: percentRange,
            topInView: topInView,
            bottomInView: bottomInView
        }

        this.isInside(percent, outputEvent);
        this.isOutside(percent, outputEvent);
    }


    /**
    *   Se l'elemento è visibile nella viewport
    *
    *   @return {void}
    */
    isInside(percent, outputEvent)
    {
        if( percent >= 0 && percent <=1 )
        {
            outputEvent.isInside = this.inside;

            if( !this.inside )
            {
                this.inside = true;
                outputEvent.inside = this.inside;

                this.callback.onInside(outputEvent, this);
            }

            this.callback.onScrollInside(outputEvent, this);
        }
    }


    /**
    *   Se l'elemento non è visibile nella viewport
    *
    *   @return {void}
    */
    isOutside(percent, outputEvent)
    {
        if( ( percent < 0 || percent > 1 ) && this.inside )
        {
            this.inside = false;
            outputEvent.inside = this.inside;

            this.callback.onOutside(outputEvent, this);
        }
    }


    /**
    *   Distruggiamo tutto
    *
    *   @return {void}
    */
    destroy()
    {
        window.removeEventListener('scroll', this.scopeOnScroll);
        window.removeEventListener('resize', this.scopeOnScroll);
    }


    /**
    *   Recuperiamo il target
    *
    *   @param  {object|string} target Il nodo del dom o la
    *                                  stringa per la query
    *
    *   @return {element} Ritorna l'elemento o null
    */
    getTarget(target)
    {
        if( typeof target === 'string' )
        {
            return document.querySelector(target);
        }
        else if( target instanceof Element )
        {
            return target;
        }
        else
        {
            return null;
        }
    }


    /**
    *   Costruiamo i parametri.
    *
    *   @param  {object} callback tutte le funzioni di callback
    *   @return {object} L'oggetto "merge"
    */
    normalizeCallbackParams(callback)
    {
        const defaultCallback =
        {
            onScrollInside: (e, t)=> {},
            onInside:       (e, t)=> {},
            onOutside:      (e, t)=> {},
        }

        if( typeof callback === 'object' )
        {
            return {...defaultCallback, ...callback};
        }

        return defaultCallback;
    }
}


/**
*   Esportiamo la funzione che ritorna il costruttore
*/
export default PercentView;